import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  tableContainer: {
    width: '100%',
    marginBottom: theme.spacing(12.5),
  },
  sectionsPaper: {
    width: '100%',
    maxWidth: '100%',
    marginTop: theme.spacing(2),
    padding: theme.spacing(0),
    borderRadius: theme.spacing(0.5),
    overflow: 'hidden',
    boxSizing: 'border-box',
    fontFamily: theme.typography.fontFamily,
    '&.MuiPaper-elevation1': {
      boxShadow: 'none',
    },
  },
  sectionsTableScroll: {
    width: '100%',
    maxWidth: '100%',
    boxSizing: 'border-box',
    '&::-webkit-scrollbar-track': {
      borderRadius: theme.spacing(2.25),
      backgroundColor: theme.palette.bgPrimary.main,
    },
    '&::-webkit-scrollbar': {
      width: theme.spacing(1),
      height: theme.spacing(1),
      backgroundColor: theme.palette.bgPrimary.main,
    },
    '&::-webkit-scrollbar-thumb': {
      width: theme.spacing(1),
      borderRadius: theme.spacing(2.25),
      backgroundColor: theme.palette.bgSecondary.main,
    },
  },
  sectionsTable: {
    width: '100%',
    tableLayout: 'fixed',
    borderCollapse: 'separate',
    borderSpacing: theme.spacing(0),
    paddingRight: theme.spacing(2),
  },
  sectionColumnCell: {
    width: theme.spacing(24),
    minWidth: theme.spacing(24),
    maxWidth: theme.spacing(24),
    boxSizing: 'border-box',
  },
  sectionHiddenColumnCell: {
    width: theme.spacing(14),
    minWidth: theme.spacing(14),
    maxWidth: theme.spacing(14),
    boxSizing: 'border-box',
    '&.MuiTableCell-body': {
      padding: theme.spacing(2, 1),
    },
    '&.MuiTableCell-head': {
      padding: theme.spacing(2, 1),
    },
  },
  sectionRowFiller: {
    width: 'auto',
    minWidth: theme.spacing(0),
    borderBottom: 'none',
    backgroundColor: 'transparent',
  },
  sectionRowFillerHead: {
    border: 'none',
  },
  sectionTableHeadRow: {
    '& > .MuiTableCell-root': {
      border: 'none',
      boxShadow: `0px -1px 0px 0px ${theme.palette.dividerV2.main} inset`,
    },
    '& > .MuiTableCell-root:nth-of-type(1)': {
      padding: theme.spacing(2),
    },
    '& > .MuiTableCell-root:nth-of-type(2)': {
      padding: theme.spacing(2, 1),
    },
    '& > .MuiTableCell-root:nth-of-type(3)': {
      padding: theme.spacing(2),
    },
  },
  sectionTableBodyCell: {
    verticalAlign: 'middle',
    borderBottom: 'none',
    padding: theme.spacing(2),
    backgroundColor: 'transparent',
    fontSize: theme.spacing(1.75),
    lineHeight: theme.spacing(3),
    color: `${theme.palette.labraText.tertiary} !important`,
  },
  sectionStripedRow: {
    cursor: 'default',
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.bgV2.light,
    },
    '&:nth-of-type(even)': {
      backgroundColor: theme.palette.common.white,
    },
    '&:hover': {
      backgroundColor: `${theme.palette.bgTertiary.light} !important`,
    },
  },
  /** Main grid `checkBox` uses marginTop for cell baseline; section rows are tighter. */
  sectionCheckBox: {
    marginTop: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  fieldLabelWithInfo: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    minWidth: theme.spacing(0),
  },
  fieldsToMapLabelWithInfo: {
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.spacing(1.75),
    fontWeight: 400,
    color: theme.palette.labraText.tertiary,
    lineHeight: theme.spacing(2.5),
    fontStyle: 'normal',
    letterSpacing: theme.spacing(0.03125),
    alignSelf: 'center',
    flexShrink: 0,
  },
  fieldInfoIcon: {
    color: '#1942C5',
    width: theme.spacing(2),
    height: theme.spacing(2),
    fontSize: theme.spacing(2),
    padding: theme.spacing(0.5),
    alignSelf: 'center',
    cursor: 'default',
    boxSizing: 'border-box',
    '& svg': {
      color: 'inherit',
    },
    '& path': {
      fill: 'currentColor',
    },
  },
  checkBox: {
    color: theme.palette.labraIcon.main,
    marginTop: theme.spacing(1),
    justifySelf: 'center',
  },
  tableCell: {
    background: theme.palette.bg.main,
    zIndex: 4,
  },
  fieldsToMapCell: {
    minWidth: theme.spacing(20),
    maxWidth: theme.spacing(20),
  },
  fieldTypeCell: {
    minWidth: theme.spacing(10),
    maxWidth: theme.spacing(10),
  },
  crmFieldsCell: {
    minWidth: theme.spacing(35),
    maxWidth: theme.spacing(35),
  },
  defaultValueCell: {
    minWidth: theme.spacing(25),
    maxWidth: theme.spacing(25),
  },
  header: {
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.spacing(1.75),
    fontWeight: 400,
    color: theme.palette.labraText.description,
    lineHeight: theme.spacing(2.5),
    letterSpacing: theme.spacing(0.03125),
    alignSelf: 'center',
  },
  fieldsToMapRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  fieldsToMap: {
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.spacing(1.75),
    fontWeight: 400,
    color: theme.palette.labraText.tertiary,
    lineHeight: theme.spacing(2.5),
    fontStyle: 'normal',
    letterSpacing: theme.spacing(0.03125),
    alignSelf: 'center',
    width: '100%',
    wordBreak: 'break-word',
    whiteSpace: 'normal',
    overflowWrap: 'break-word',
  },
  inputText: {
    width: theme.spacing(33.375),
  },
  inputSelect: {
    display: 'inline-flex',
    alignItems: 'center',
    backgroundColor: 'transparent',
    height: 'fit-content',
    alignSelf: 'center',
    width: 'fit-content',
    maxWidth: '100%',
    /**
     * Tighten Outlined Select vertical padding inside NestedDropdown (replaces fragile
     * `@global` + Emotion hash selector from PR feedback).
     */
    '& .MuiSelect-select': {
      paddingTop: theme.spacing(1.25),
      paddingBottom: theme.spacing(1.25),
    },
  },
}))
